import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/Login';
import AdminLayout from './pages/admin/AdminLayout';
import WhatsAppWidget from './components/WhatsAppWidget';
import ScrollToTop from './components/ScrollToTop';

const PrivateRoute = ({ children }) => {
  const { isAuth } = useAuth();
  return isAuth ? children : <Navigate to="/yonetim/giris" replace />;
};

const PublicLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <WhatsAppWidget />
  </div>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/urunler" element={<PublicLayout><Products /></PublicLayout>} />
          <Route path="/urunler/:slug" element={<PublicLayout><ProductDetail /></PublicLayout>} />
          <Route path="/hizmetler" element={<PublicLayout><Services /></PublicLayout>} />
          <Route path="/hizmetler/:slug" element={<PublicLayout><ServiceDetail /></PublicLayout>} />
          <Route path="/hakkimizda" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/iletisim" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/yonetim/giris" element={<AdminLogin />} />
          <Route path="/yonetim/*" element={<PrivateRoute><AdminLayout /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
